(function(){
  const LEADERBOARD_API='https://gizmos-retrocade-site.vercel.app';
  const MEMBER_PROXY='/apps/retrocade-member';
  const DEVICE_ID_KEY='gizmos_arcade_device_id_v2';
  const ALIAS_PREFIX='gizmos_arcade_alias_v2:';
  const ADJ=['NEON','PIXEL','TURBO','HYPER','GLITCH','VAPOR','CHROME','LASER','COSMIC','ASTRO','RIVER','FOG'];
  const NOUN=['RIDER','GIZMO','RAIDER','COMET','BYTE','BLASTER','NOVA','BUOY','OTTER','PILOT','VECTOR','GULL'];

  function randomAlias(){return `${ADJ[(Math.random()*ADJ.length)|0]}-${NOUN[(Math.random()*NOUN.length)|0]}-${100+((Math.random()*900)|0)}`;}
  function canonicalMemberAlias(customerId){
    const id=String(customerId||'').trim();
    if(!/^\d+$/.test(id))return '';
    let hash=2166136261;
    const input=`gizmos-retrocade-member:${id}`;
    for(let index=0;index<input.length;index+=1){
      hash^=input.charCodeAt(index);
      hash=Math.imul(hash,16777619)>>>0;
    }
    return `${ADJ[hash%ADJ.length]}-${NOUN[(hash>>>8)%NOUN.length]}-${100+((hash>>>16)%900)}`;
  }
  function randomDeviceId(){
    try{if(crypto&&typeof crypto.randomUUID==='function')return crypto.randomUUID();}catch(error){}
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,14)}`;
  }
  function getStored(key){try{return localStorage.getItem(key)||'';}catch(error){return '';}}
  function setStored(key,value){try{localStorage.setItem(key,value);}catch(error){}}

  function getIdentity(root){
    const customerId=String(root.dataset.shopifyCustomerId||'').trim();
    let playerId='';
    let playerAlias='';
    if(customerId){
      playerId=`shopify:${customerId}`;
      playerAlias=canonicalMemberAlias(customerId);
      setStored(ALIAS_PREFIX+playerId,playerAlias);
    }else{
      let deviceId=getStored(DEVICE_ID_KEY);
      if(!deviceId){deviceId=randomDeviceId();setStored(DEVICE_ID_KEY,deviceId);}
      playerId=`device:${deviceId}`;
      const aliasKey=ALIAS_PREFIX+playerId;
      playerAlias=getStored(aliasKey).toUpperCase().replace(/[^A-Z0-9 _-]/g,'').trim().slice(0,28);
      if(!playerAlias){playerAlias=randomAlias();setStored(aliasKey,playerAlias);}
    }
    return {playerId,playerAlias,isShopifyCustomer:Boolean(customerId)};
  }

  function withIdentity(value,identity){
    try{
      const url=new URL(value,window.location.href);
      url.searchParams.set('playerId',identity.playerId);
      url.searchParams.set('playerAlias',identity.playerAlias);
      return url.toString();
    }catch(error){return value;}
  }

  function text(tag,className,value){const el=document.createElement(tag);if(className)el.className=className;el.textContent=value;return el;}
  function formatScore(value){return Number(value||0).toLocaleString();}

  function buildRow(entry,isMe){
    const row=document.createElement('div');
    row.className='online-lb-row'+(isMe?' is-me':'');
    row.append(
      text('span','online-lb-rank',`#${entry.rank}`),
      text('span','online-lb-name',`${entry.alias||'PLAYER'}${isMe?' · YOU':''}`),
      text('span','online-lb-score',formatScore(entry.score)),
    );
    return row;
  }

  async function loadVerifiedMember(root,identity,statusEl){
    const card=root.querySelector('[data-retrocade-member-card]');
    if(!card||!identity.isShopifyCustomer)return;

    const label=card.querySelector('[data-member-label]');
    const memberAlias=card.querySelector('[data-member-alias]');
    const boardAlias=root.querySelector('[data-lb-player-alias]');
    const copy=card.querySelector('[data-member-copy]');
    const rewardStatus=card.querySelector('[data-member-reward-status]');
    const rewardDetail=card.querySelector('[data-member-reward-detail]');

    if(rewardStatus)rewardStatus.textContent='Verifying member…';
    if(rewardDetail)rewardDetail.textContent='Confirming your Retrocade Member reward account.';

    try{
      const response=await fetch(MEMBER_PROXY,{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
      const payload=await response.json().catch(()=>({}));
      if(!response.ok||payload.ok===false)throw new Error(payload.error||'Verification failed.');

      if(payload.verified===true&&payload.authenticated===true&&payload.memberType==='retrocade_member'){
        const serverAlias=String(payload.playerAlias||'').toUpperCase().replace(/[^A-Z0-9 _-]/g,'').trim().slice(0,28);
        if(serverAlias){
          identity.playerAlias=serverAlias;
          setStored(ALIAS_PREFIX+identity.playerId,serverAlias);
          if(memberAlias)memberAlias.textContent=serverAlias;
          if(boardAlias)boardAlias.textContent=serverAlias;
        }
        const balance=Number(payload.rewards?.balance||0);
        card.classList.add('is-verified');
        if(label)label.textContent='Verified Retrocade Member';
        if(copy)copy.textContent="Your Gizmo's account is securely verified. Eligible play can count toward future physical arcade-token rewards.";
        if(rewardStatus)rewardStatus.textContent=`${balance.toLocaleString()} reward point${balance===1?'':'s'}`;
        if(rewardDetail)rewardDetail.textContent='Verified account · earning rules and physical-token conversion will be added later.';
        if(statusEl)statusEl.textContent='Verified Retrocade Member · rewards account connected';
        return;
      }

      card.classList.remove('is-verified');
      if(label)label.textContent='Retrocade Member';
      if(copy)copy.textContent='Your store account is signed in, but reward verification is not currently active.';
      if(rewardStatus)rewardStatus.textContent='Rewards not verified';
      if(rewardDetail)rewardDetail.textContent='Leaderboard play still works. Reward crediting stays disabled until verification succeeds.';
      if(statusEl)statusEl.textContent='Retrocade Member · reward verification unavailable';
    }catch(error){
      card.classList.remove('is-verified');
      if(label)label.textContent='Retrocade Member';
      if(rewardStatus)rewardStatus.textContent='Verification temporarily unavailable';
      if(rewardDetail)rewardDetail.textContent='Your leaderboard scores still work. No redeemable rewards can be credited until verification succeeds.';
      if(statusEl)statusEl.textContent='Retrocade Member · reward verification temporarily unavailable';
    }
  }

  function initLeaderboard(scope){
    const roots=(scope.matches&&scope.matches('[data-online-arcade]'))?[scope]:[...scope.querySelectorAll('[data-online-arcade]')];
    roots.forEach(root=>{
      const board=root.querySelector('[data-online-leaderboard]');
      if(!board||board.dataset.ready==='true')return;
      board.dataset.ready='true';

      const identity=getIdentity(root);
      const aliasEl=board.querySelector('[data-lb-player-alias]');
      const statusEl=board.querySelector('[data-lb-player-status]');
      if(aliasEl)aliasEl.textContent=identity.playerAlias;
      if(statusEl)statusEl.textContent=identity.isShopifyCustomer?'Retrocade Member · verifying rewards account':'Guest Player · scores stay with this browser';

      const memberCard=root.querySelector('[data-retrocade-member-card]');
      if(memberCard){
        const memberAlias=memberCard.querySelector('[data-member-alias]');
        if(memberAlias)memberAlias.textContent=identity.playerAlias;
        const memberAction=memberCard.querySelector('.retrocade-member-action');
        if(memberAction&&!identity.isShopifyCustomer){
          memberAction.href='/customer_authentication/login?return_to=%2F%23play';
        }
      }

      loadVerifiedMember(root,identity,statusEl);

      const boothLink=root.querySelector('[data-online-booth-link]');
      if(boothLink){
        const base=boothLink.dataset.boothUrl||boothLink.getAttribute('href')||'';
        boothLink.href=withIdentity(base,identity);
      }

      const gameTabs=[...board.querySelectorAll('[data-lb-game]')];
      const periodTabs=[...board.querySelectorAll('[data-lb-period]')];
      const rowsEl=board.querySelector('[data-lb-rows]');
      const summaryEl=board.querySelector('[data-lb-summary]');
      const limit=Math.max(5,Math.min(20,Number(board.dataset.limit||10)||10));
      let activeGame=gameTabs.find(button=>button.classList.contains('is-active'))?.dataset.lbGame||gameTabs[0]?.dataset.lbGame||'gizmo-quest';
      let activePeriod=periodTabs.find(button=>button.classList.contains('is-active'))?.dataset.lbPeriod||'all';
      let requestSerial=0;

      function markTabs(){
        gameTabs.forEach(button=>{
          const active=button.dataset.lbGame===activeGame;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-pressed',active?'true':'false');
        });
        periodTabs.forEach(button=>{
          const active=button.dataset.lbPeriod===activePeriod;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-pressed',active?'true':'false');
        });
      }

      async function load(){
        if(!rowsEl)return;
        const serial=++requestSerial;
        rowsEl.replaceChildren(text('div','online-lb-loading','Loading scores…'));
        try{
          const url=new URL(`${LEADERBOARD_API}/api/leaderboard`);
          url.searchParams.set('game',activeGame);
          url.searchParams.set('period',activePeriod);
          url.searchParams.set('limit',String(limit));
          url.searchParams.set('player',identity.playerId);
          const response=await fetch(url.toString(),{mode:'cors',cache:'no-store'});
          const payload=await response.json().catch(()=>({}));
          if(serial!==requestSerial)return;
          if(!response.ok||payload.ok===false)throw new Error(payload.error||'Could not load leaderboard.');
          rowsEl.replaceChildren();
          const entries=Array.isArray(payload.entries)?payload.entries:[];
          const me=payload.me||null;
          if(!entries.length){
            rowsEl.append(text('div','online-lb-empty','No scores yet for this period — be the first on the board.'));
          }else{
            entries.forEach(entry=>rowsEl.append(buildRow(entry,Boolean(me&&entry.rank===me.rank))));
          }
          if(me&&me.rank>entries.length){
            rowsEl.append(text('div','online-lb-divider','Your position'));
            rowsEl.append(buildRow(me,true));
          }
          if(summaryEl){
            const periodLabel=activePeriod==='today'?'today':activePeriod==='week'?'this week':'all time';
            let summary=`${Number(payload.totalPlayers||0).toLocaleString()} player${Number(payload.totalPlayers||0)===1?'':'s'} · ${periodLabel}`;
            if(me)summary+=` · Your best: ${formatScore(me.score)} (#${me.rank})`;
            summaryEl.textContent=summary;
          }
        }catch(error){
          if(serial!==requestSerial)return;
          rowsEl.replaceChildren(text('div','online-lb-error','Leaderboard is temporarily unavailable. Your game scores can still be played and saved.'));
          if(summaryEl)summaryEl.textContent='';
        }
      }

      gameTabs.forEach(button=>button.addEventListener('click',()=>{activeGame=button.dataset.lbGame||activeGame;markTabs();load();}));
      periodTabs.forEach(button=>button.addEventListener('click',()=>{activePeriod=button.dataset.lbPeriod||activePeriod;markTabs();load();}));
      window.addEventListener('message',event=>{
        const data=event.data;
        if(!data||data.source!=='gizmos-arcade'||data.type!=='gameResult'||!data.result)return;
        if(String(data.result.gameId||'')===activeGame&&data.leaderboard)load();
      });

      markTabs();
      load();
    });
  }

  document.addEventListener('DOMContentLoaded',()=>initLeaderboard(document));
  document.addEventListener('shopify:section:load',event=>initLeaderboard(event.target));
})();
